export const getUserPermissions = (email: string) => {
	return {
		method: 'GET',
		url: `${process.env.REACT_APP_ORIGIN}/users/byEmail/${email}`,
	}
}
